import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {routing} from './donar-list.routing';
import {DonarListComponent} from './donar-list.component';
import {SharedTranslationModule} from '../../shared/change-language/shared-translation.module';
import {Daterangepicker} from 'ng2-daterangepicker';
import {AutoCompleteModule, ConfirmDialogModule, DialogModule, PanelModule} from 'primeng/primeng';
import {SafeUrlModule} from '../../shared/custom-pipe/safe-url.module';
import {ReactiveFormsModule} from '@angular/forms';
import {NgxBarcodeModule} from 'ngx-barcode';
import {DonarListService} from './donar-list.service';
import {RequisitionListService} from '../requisition-list/requisition-list.service';

@NgModule ({
    imports: [
        CommonModule, SharedTranslationModule,
        routing,ReactiveFormsModule,
        Daterangepicker,
        NgxBarcodeModule,
        SharedTranslationModule,
        ConfirmDialogModule,
        DialogModule,
        AutoCompleteModule,
        PanelModule,
        SafeUrlModule,

    ],
    declarations: [DonarListComponent],
    providers: [
        DonarListService
    ]

})
export class DonarListModule {
}





// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/donar-list/donar-list.module.ts